module.exports = __webpack_public_path__ + "static/media/events-add-safety-risk-people.069807b0.svg";